import '@js-joda/timezone';
import { Card, Col, Container, Row } from "react-bootstrap";

//spotsync data
import { useState, useEffect, useRef } from "react";
import { useLoaderData, useNavigate, useRouteLoaderData } from "react-router-dom";
import { PageTitle } from "./Controls/PageTitle";
import { FacilityStats } from "./Data/ApiTypes";
import { cents, showMoneyShort } from "./Data/Money";
import { ExtendedFacility } from ".";
import { pluralize } from "./Data/English";
import { HeaderText } from "./Controls/HeaderText";
import { CSSTransition } from "react-transition-group";
import TourGuide from './Controls/TourGuide';
import './FacilityOverviewPage.css';

interface OverviewCardProps {
    size?: number;
    label?: string;
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    to?: string;
}

function OverviewCard({ size = 1,
    label = "",
    className = "",
    children = <></>,
    style = {},
    to }: OverviewCardProps) {

    const nav = useNavigate();
    if (!!to) {
        className += "zoom-small-link";
    }
    return <Col xs={6} lg={6} xl={4}>
    <Card
    className={`shadow py-2 h-100 border-2 zoom-small rounded-4  ${className}`}
    onClick={() => to !== undefined ? nav(to) : 0}
    >
        <Card.Body className="d-flex flex-column text-wrap">
            <div className={`w-100 flex-grow-1 text-center fw-bold overview-value`}>
            {children}
            </div>
            <div className="text-center text-muted text-wrap">
            {label}
            </div>
        </Card.Body>
    </Card>
    </Col>;
}

export function FacilityOverviewPage() {
    const facility = useRouteLoaderData("facility") as ExtendedFacility;
    const stats = useLoaderData() as FacilityStats;
    const [showContent, setShowContent] = useState(false);
    const nodeRef = useRef(null);

    // Trigger transition on component mount
    useEffect(() => {
        setShowContent(true);
    }, []);

    /*
        const ords = stats.orderStats;
        const subs = stats.subscriptions;
        const totalPaid  = ords.filter( o => o.isPaid  ).map( o => o.price ).reduce( addMon, cents( 0 ) );
        const totalDebt  = ords.filter( o => !o.isPaid ).map( o => o.price ).reduce( addMon, cents( 0 ) );
        const activeSubs = subs.filter( s => s.status === SubscriptionStatus.Active );    
        const totSpots = activeSubs.map( s => s.qty ).reduce( addNum, 0 );
        const avgSpots = totSpots / activeSubs.length;    */
    function facilityLink(link: string) { return `/facility/${facility.facilityId}/${link}`; }
    return <CSSTransition
        in={showContent}
        timeout={300}
        classNames="page-slide"
        unmountOnExit
        nodeRef={nodeRef}
    >

        <Container fluid className="mb-3" ref={nodeRef}>
            <Row>
                <Col>
                    <PageTitle>
                        {facility.name}
                    </PageTitle>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col className="d-flex align-items-center">
                    <HeaderText>Monthly Parking</HeaderText>
                </Col>
            </Row>
            <Row className="gy-3 gx-3">
                <OverviewCard label={pluralize(stats.pendingParkers, "New Application", "New Applications")}
                    to={facilityLink("parker/applied")}>
                    {stats.pendingParkers}
                </OverviewCard>
                <OverviewCard label="Active Plans" to={facilityLink("parker")}>
                    {stats.totalMonthlyParkerCount}
                </OverviewCard>
                <OverviewCard label="Monthly Recurring Revenue" to={facilityLink("parker")}>
                    {showMoneyShort(cents(stats.monthlyRecurringRevenue))}
                </OverviewCard>


            </Row>
            <Row className="mt-3">
                <Col>
                    <HeaderText>
                        Transient Parking
                    </HeaderText>
                </Col>
            </Row>
            <Row className="gy-3 gx-3">
                <OverviewCard label="Active Transient" to={facilityLink("status")}>
                    {stats.activeReservations}
                </OverviewCard>
                <OverviewCard label="Upcoming Transient" to={facilityLink("status/upcoming")}>
                    {stats.upcomingReservations}
                </OverviewCard>
                <OverviewCard label="Last 30 Days Transient Revenue" to={facilityLink("status/previous")}>
                    {showMoneyShort(cents(stats.currentMonthTransientRevenue))}
                </OverviewCard>
            </Row>
            <Row className="mt-3">
                <Col>
                    <HeaderText>
                        Receivables
                    </HeaderText>
                </Col>
            </Row>
            <Row className="gy-3 gx-3">


                <OverviewCard label="Total Unpaid Balance" to={facilityLink("finance/invoice")}>
                    {showMoneyShort(cents(stats.totalUnpaidBalance))}
                </OverviewCard>
                <TourGuide  tourKey="facilityOverview" ></TourGuide>
            </Row>
        </Container>
    </CSSTransition>;
}